import './prototype/big-number';
import './rxjs';

import { HttpClient, HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpModule } from 'ngx-libs-http';
import { environment } from 'src/environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppTranslateLoader } from './app-translate-loader';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { CONFIGURATION } from './services/configuration';
import { walletConfig as ethWalletConfig } from './eth-wallet-config';
import { LibsModule, ActionCableModule } from 'ngx-libs';
import BigNumber from 'bignumber.js';

BigNumber.config({ DECIMAL_PLACES: 27 });

const main = HttpModule.create('main', { baseUrl: environment.apiUrl, auth: false });
const auth = HttpModule.create('auth', { baseUrl: environment.apiUrl, auth: true, accessTokenKey: 'ACCESS_TOKEN' });
const admin = HttpModule.create('admin', { baseUrl: environment.apiUrl, auth: true, accessTokenKey: 'ADMIN_ACCESS_TOKEN' });

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useClass: AppTranslateLoader,
        deps: [HttpClient]
      }
    }),
    HttpModule.forRoot(),
    HttpClientModule,
    HttpClientJsonpModule,
    LibsModule.forRoot(),
    ActionCableModule.forRoot({
      actionCableUrl: environment.wsUrl
    }),
    SharedModule
  ],
  providers: [
    { provide: CONFIGURATION, useValue: ethWalletConfig },
    ...admin.providers,
    ...auth.providers,
    ...main.providers
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
